// 국가번호 중복으로 인해 커스텀하는 국가번호 리스트
export const excludedCountryCodes = [
  '1',
  '7',
  '39',
  '44',
  '47',
  '61',
  '212',
  '262',
  '290',
  '358',
  '590',
  '599',
]
//중복 제외 후 중복 국가번호 재추가 국가번호 리스트
export const addCountryList = [
  'US',
  'RU',
  'IT',
  'GB',
  'NO',
  'AU',
  'MA',
  'YT',
  'SH',
  'FI',
  'GP',
  'CW',
]
